import React from 'react';
import PropTypes from 'prop-types';

import NavItemPic from './components/NavItemButtonPic';
import NavItemTxt from './components/NavItemButtonTxt';

const NavItemButton = ({ notifs, data, displayLink }) => (
  data.labels.icon
    ? <NavItemPic notifs={notifs} data={data} />
    : <NavItemTxt notifs={notifs} data={data} displayLink={displayLink} />
);

NavItemButton.propTypes = {
  notifs: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
  data: PropTypes.oneOfType([
    NavItemTxt.propTypes.data,
    NavItemPic.propTypes.data,
  ]).isRequired,
  displayLink: PropTypes.bool,
};

NavItemButton.defaultProps = {
  notifs: null,
  displayLink: undefined,
};

export default NavItemButton;
